import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
export var ThemedEventQuestsRewardIcons = function (_a) {
    var taskIcons = _a.taskIcons, activeQuestEpisode = _a.activeQuestEpisode;
    return (React.createElement("div", { className: "flex flex--around" }, taskIcons.map(function (icon, index) {
        var isLocked = activeQuestEpisode < index + 1;
        var completedIcon = activeQuestEpisode > index + 1 ? (React.createElement(Icon, { icon: IdIcon.CheckIcn, styleId: IdStyles.IconLarge })) : ("");
        return (React.createElement("div", { className: "reward-icon-container flex flex--guts ", key: "reward-icon-" + index },
            React.createElement(Icon, { icon: icon, styleId: IdStyles.IconLarge, isLocked: isLocked }),
            React.createElement("div", { className: "reward-icon-completed" }, completedIcon)));
    })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/ThemedEventQuestsRewardIcons.tsx
// module id = 2770
// module chunks = 3